module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "ecco-surface-height-change--dataset-cover.eddd714b.jpg";